<!--
 * @Description: 编辑商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2023-03-07 15:29:20
 * @LastEditors: mdb
-->
<template>
  <CosLayoutMain>
    <template #content>
      <BusinessForm
        ref="businessFormRef"
        :title="t('business.fx028r')"
        type="edit"
        v-model:value="dataForm"
        @update:value="fetch"
      />
    </template>
    <template #footer>
      <a-button @click="goBack()">{{ t('btn.cancel') }}</a-button>
      <a-button :loading="loading" @click="handleReset()">{{ t('btn.reset') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleSubmit()">{{ t('btn.save') }}</a-button>
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit, businessDetails } from '@/api/overseasSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
const route = useRoute()
const { t } = useI18n()

const initForm: FbuBusinessEditParams = reactive({})
const dataForm = reactive<FbuBusinessEditParams>({})

onBeforeMount(() => {
  businessDetails({ id: route.query.id }).then((res) => {
    res.data.tailWarehouse = res.data.tailWarehouse || undefined
    res.data.tailProductName = res.data.tailProductName || undefined
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}

const businessFormRef = ref()
const handleReset = () => {
  for (const key in dataForm) {
    dataForm[key] = undefined
  }
  Object.assign(dataForm, cloneDeep(initForm))
  setTimeout(() => {
    businessFormRef.value?.clearValidate()
  })
}
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(() => {
    loading.value = true
    const params = toRaw(dataForm)
    businessCreateOrEdit(params)
      .then(() => {
        message.success(t('business.sima2a'))
        businessFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuBusinessEdit' }
</script>

<style scoped></style>
